import { render, staticRenderFns } from "./TikTokStoreNeedsReconnectionModal.vue?vue&type=template&id=a4f558ac&scoped=true"
import script from "./TikTokStoreNeedsReconnectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TikTokStoreNeedsReconnectionModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TikTokStoreNeedsReconnectionModal.vue?vue&type=style&index=0&id=a4f558ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f558ac",
  null
  
)

export default component.exports